import { Grid, Stack, Typography } from '@mui/material'
import Lottie from 'lottie-react'
import animationData from '../../../Appointment/assets/lottie/cancel.json'
import { Loading } from '../../Common/Loading'
import { useReservation } from '../../../../hooks/useReservation'
import { CreateNewButton } from '../../Common/CreateNewButton'
import { useTranslation } from 'react-i18next'

const CancelSuccess = () => {
  const { t } = useTranslation()
  const { reservation, isLoading: isLoadingReservation } = useReservation()

  if (isLoadingReservation) return <Loading />
  if (!reservation) return null

  return (
    <Grid container textAlign={'center'} spacing={1}>
      <Grid item xs={12}>
        <Lottie animationData={animationData} loop={false} style={{ height: '12rem' }} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h1" p={1}>
          {t('pages.appointment.cancel.reservationCanceled')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Stack direction={'row'} spacing={2} justifyContent={'center'} alignItems={'center'}>
          <CreateNewButton reservation={reservation} />
        </Stack>
      </Grid>
    </Grid>
  )
}

export { CancelSuccess as ReservationCancelSuccess }
